// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__TdCAW","dragIcon":"SortableItem_dragIcon__2D9cX","disabled":"SortableItem_disabled__1OLO2"};